import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { getAccountRouteToComplete } from '../Account/accountCompletionValidators';
import DashboardRoutes from './DashboardRoutes';
import AccountIncomplete from './AccountIncomplete';
import withLayout from '../withLayout';
import Footer from '../../Layouts/Footer';

const Dashboard = ({ investorUser, tenant }) => (
  <Fragment>
    {investorUser.canViewOffers ? (
      <DashboardRoutes />
    ) : (
      <AccountIncomplete
        accountRouteToComplete={getAccountRouteToComplete(investorUser)}
      />
    )}
    <Footer tenant={tenant} />
  </Fragment>
);

Dashboard.propTypes = {
  investorUser: PropTypes.object.isRequired,
};

const DashboardWithState = connect(({ investorUser, tenant }) => ({
  investorUser,
  tenant,
}))(Dashboard);

const DashboardWithLayout = withLayout(DashboardWithState);

export default DashboardWithLayout;



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js